import { forwardRef } from '@chakra-ui/system';
import * as React from 'react';
import { DropdownButton } from './DropdownButton';
import { DropdownComponent, IDropdownComponentProps } from './DropdownComponent';
import { DropdownGroup } from './DropdownGroup';
import { DropdownOption } from './DropdownOption';
import { DropdownSection } from './DropdownSection';

export type IDropdownProps = IDropdownComponentProps;

type IDropdownComponent = React.FunctionComponent<IDropdownComponentProps> & {
  Section: typeof DropdownSection;
  Option: typeof DropdownOption;
  Group: typeof DropdownGroup;
  Button: typeof DropdownButton;
};

export const Dropdown = forwardRef<IDropdownComponentProps, 'div'>((props, ref) => {
  return <DropdownComponent {...props} ref={ref} />;
}) as IDropdownComponent;

Dropdown.Section = DropdownSection;
Dropdown.Option = DropdownOption;
Dropdown.Group = DropdownGroup;
Dropdown.Button = DropdownButton;
